module.exports = __webpack_public_path__ + "img/googleplay_2208x1242_01_ShrmpMnia.a976dc8d.png";